import { apiTypes } from 'shared/consts/handbooksApiTypes';


const config = {
  schema: 'mgt',
  table: 'vehicles',
  title: 'Транспортные средства',
  apiType: apiTypes.REPORT_API,
  elemsOnPage: 100,
  connections: {
    // vehiclemodel: {
    //   apiType: apiTypes.REPORT_API,
    //   table: 'asmpp_sensor_type',
    //   fields: [],
    //   autocomplete: true,
    //   format: (elem: any) => elem['name'],
    //   index: 'id'
    // },
    transporttype: {
      apiType: apiTypes.REPORT_API,
      table: 'vehicle_types',
      fields: [],
      autocomplete: true,
      format: (elem: any) => elem['name'],
      index: 'id'
    },
    depots: {
      apiType: apiTypes.REPORT_API,
      table: 'depots',
      fields: [],
      autocomplete: true,
      format: (elem: any) => elem['name'],
      index: 'id'
    },
    capacitytype: {
      apiType: apiTypes.REPORT_API,
      table: 'capacity_types',
      fields: [],
      autocomplete: true,
      format: (elem: any) => elem['name'],
      index: 'id'
    },
    temp_sensor_types: {
      apiType: apiTypes.REPORT_API,
      table: 'temp_sensor_types',
      fields: [],
      autocomplete: true,
      format: (elem: any) => elem['sensor_type'],
      index: 'id'
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'depot_id',
      title: 'Филиал',
      type: 'text',
      connection: 'depots',
      id_type: 'number',
      required: false,
    },
    {
      name: 'vehicle_type_id',
      title: 'Тип ТС',
      type: 'text',
      connection: 'transporttype',
      required: false,
      id_type: 'number',
    },
    {
      name: 'model',
      title: 'Марка/Модель',
      type: 'text',
      // connection: 'vehiclemodel',
      // id_type: 'number',
      required: false,
      maxLengthValue: 50  // remove
    },
    {
      name: 'capacity_type_id',
      title: 'Вместимость',
      type: 'text',
      connection: 'capacitytype',
      required: false,
      id_type: 'number',
    },
    {
      name: 'depot_number',
      title: 'Гаражный номер',
      type: 'number',
      required: true,
      minValue: 0,
      maxValue: 2147483647,
    },
    {
      name: 'state_number',
      title: 'ГРЗ',
      type: 'text',
      required: false,
      maxLengthValue: 12
    },
    {
      name: 'vin',
      title: 'VIN-номер',
      type: 'text',
      required: false,
      maxLengthValue: 25
    },
    {
      name: 'peer_address',
      title: 'Адрес участника соединения',
      type: 'bignumber',
      required: false,
      maxValue: '9223372036854775807',
    },
    {
      name: 'devtempsens',
      title: 'Датчики температуры',
      type: 'temperatureSensorModal',
      connection: 'temp_sensor_types',
      disableFilter: true,
      disableSort: true,
    },
    // {
    //   name: 'do_not_update',
    //   title: 'Отключить автообновление',
    //   type: 'boolean',
    //   required: false,
    //   width: '205px',
    // },
  ],
  convertFunctions: {
    peer_address: (value: any) => value && value.toString()
  },
  newTemplate: {
    id: null,
    depot_id: null,
    vehicle_type_id: null,
    model: null,
    capacity_type_id: null,
    depot_number: null,
    state_number: null,
    vin: null,
    peer_address: null,
    // do_not_update: false
  },
  updateField: 'update_date',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'vehicle_id',
        field: 'vehicle_id',
      },{
        title: 'ts_type_code',
        field: 'route_type',
      },
      {
        title: 'vin',
        field: 'vin',
      },
      {
        title: 'model',
        field: 'model',
      },
      {
        title: 'gos_nomer',
        field: 'gos_nomer',
      },
      {
        title: 'depot_id',
        field: 'depot_id',
      },
      {
        title: 'depot_number',
        field: 'depot_number',
      },
      {
        title: 'column',
        field: 'column',
      },
      {
        title: 'capacity_id',
        field: 'capacity_id',
      },
      {
        title: 'peer_address',
        field: 'peer_address',
      }
    ],
    example: `1;A;JHMZE2H73AS009608;МАЗ;А111АА170;1;111222;1;1;1`,
  },
};

export default config;
